
    import './styles.scoped.css';
    export default {
  "tutorial-list": "awsui_tutorial-list_1u70p_29idd_93",
  "tutorial-title": "awsui_tutorial-title_1u70p_29idd_106",
  "task": "awsui_task_1u70p_29idd_113",
  "task-title": "awsui_task-title_1u70p_29idd_121",
  "task-title--status": "awsui_task-title--status_1u70p_29idd_129",
  "current-task": "awsui_current-task_1u70p_29idd_133",
  "successful-task": "awsui_successful-task_1u70p_29idd_137",
  "congratulation-message": "awsui_congratulation-message_1u70p_29idd_141",
  "congratulation-message--status": "awsui_congratulation-message--status_1u70p_29idd_149",
  "plaintext-congratulation-description": "awsui_plaintext-congratulation-description_1u70p_29idd_153",
  "divider": "awsui_divider_1u70p_29idd_157",
  "step-list": "awsui_step-list_1u70p_29idd_161",
  "step": "awsui_step_1u70p_29idd_161",
  "expandable-section-wrapper": "awsui_expandable-section-wrapper_1u70p_29idd_170",
  "expandable-section-header": "awsui_expandable-section-header_1u70p_29idd_174",
  "step-title": "awsui_step-title_1u70p_29idd_179",
  "feedback-link": "awsui_feedback-link_1u70p_29idd_180",
  "dismiss-button": "awsui_dismiss-button_1u70p_29idd_181",
  "completion-screen-title": "awsui_completion-screen-title_1u70p_29idd_182",
  "completion-screen-description": "awsui_completion-screen-description_1u70p_29idd_183"
};
  